import { applyMiddleware, createStore } from "redux";
import { thunk } from "redux-thunk";
import { createLogger } from "redux-logger";
import { clearDetailsReferrer } from "../../features/AccountingTasks/services/store/accountingTasksActions";
import rootReducer from "./index";

const loggerMiddleware = createLogger();

export const store = createStore(rootReducer, applyMiddleware(thunk, loggerMiddleware));

if (document.documentURI && !document.documentURI.includes("accountingTasks")) {
    store.dispatch(clearDetailsReferrer());
}
